export const BASE_PATH = "/help-support";
